import React from 'react'
import BannerMainImageSection from '../../bannerMainImageSection'
import { Row, Col } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import { PrimaryButton } from '@mmsg/louie'
import * as E from './bannerSectionElements'

const BannerSection = ({
  data: { nlQuoteNumber, brand, userFirstName, isConsultant },
  applicationRole,
}) => {
  let history = useHistory()
  const GoBackToEstimatesPage = () => {
    if (isConsultant) {
      history.push('/consultant/estimates')
    } else {
      history.push('/estimates')
    }
  }

  return (
    <div className="banner-estimate-bg">
      <BannerMainImageSection>
        <div>
          <button
            data-html2canvas-ignore="true" // this could be the reason for small difference in canvas for pdf
            className="banner-button theme-light btn-icon-back btn mb-3 print hide-to-print"
            onClick={GoBackToEstimatesPage}
          >
            Back to comparison
          </button>
        </div>
        <Row>
          <Col lg={10} xs={12}>
            <E.BannerHeader>
              Your Oly estimate is here - {nlQuoteNumber}
            </E.BannerHeader>
            <p className="mt-2 text-left">
              Ready to choose your new car? The open road is calling your name...
            </p>
          </Col>
        </Row>
      </BannerMainImageSection>
    </div>
  )
}

export default BannerSection
